<template>
  <div class="common-limit">
    <Breadcrumb></Breadcrumb>
    <div class="form-body line-height-40">
      <div>
        支付类型：订单货款
      </div>
      <div>
        支付明细：
      </div>

      <div>
        <el-row :gutter="24" type="flex" justify="space-between">
          <el-col :span="8">
            订单总数： 2
            <div style="display: inline-block; margin-left: 10px">
              [可支付订单：<span class="el-button--text">2</span> &nbsp;&nbsp; 不可支付订单：
              <span class="form-required">0</span>]
            </div>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.out_of_stock_order"
              >缺货订单（<span class="form-required">0</span>）</el-checkbox
            >
          </el-col>
        </el-row>
        <el-table :data="data" class="border" header-cell-class-name="table-header" style="width: 100%">
          <el-table-column type="selection" width="55" align="center"></el-table-column>

          <el-table-column prop="id" label="序号"> </el-table-column>
          <el-table-column prop="number" label="订单编号" width="220px">
            <template slot-scope="scope">
              <span>
                {{ scope.row.number }}
              </span>
              <span
                v-if="scope.row.is_out_of_stock"
                style="display: inline-block; padding: 0 3px; background: #f56c6c;color:#fff; border-radius: 6px"
                >缺货</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="count" label="总件数"> </el-table-column>
          <el-table-column prop="price" label="产品货款"> </el-table-column>
          <el-table-column prop="fee" label="运费"> </el-table-column>
          <el-table-column prop="totalPrice" label="贷款总计"> </el-table-column>
          <el-table-column prop="logisticsType" label="物流方式"> </el-table-column>
        </el-table>
      </div>
      <div class="payTypeWrapper">
        <el-row :gutter="24">
          <el-col :span="2">
            支付方式：
          </el-col>
          <el-col :span="20">
            <div style="padding:  0 0 10px 0">
              <el-radio v-model="pay_type" style="width: 135px;text-align: center" label="balance" border>
                                账户余额
                              <i class="iconfont icon-checked">&#xe8b7;</i>
                            </el-radio>
            </div>
            <div style="width: 400px;background: #eef5fa;border: 1px solid #4934b2;padding: 5px 10px;">
              <el-row :gutter="24">
                <el-col :span="10">支付账户: manba1205(xx)</el-col>
                <el-col :span="10">可用余额 <span class="form-required">12312313</span>元</el-col>
                <el-col :span="4"><i class="el-icon-refresh"></i> 充值</el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2">
            应付金额：
          </el-col>
          <el-col :span="20"> <span class="form-required" style="font-size: 24px">333.23</span> 元 </el-col>
          <el-col>
            <el-button type="primary">立即支付</el-button>
          </el-col>
          <el-col>
            <div>
              <el-checkbox checked></el-checkbox>
              我已经阅读并同意 <el-button type="text">《指纹平台物流协议》</el-button>,
              <el-button type="text">《指纹平台售后政策》</el-button> 和
              <el-button type="text">《指纹平台法律声明》</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  name: 'payBill',
  components: { Breadcrumb },
  data() {
    return {
      data: [
        {
          id: 1,
          number: 'ZW875656757878',
          count: 201,
          price: '￥3054.92',
          fee: '￥243',
          totalPrice: '￥3297.92',
          logisticsType: '顺丰国内',
        },
        {
          id: 2,
          number: 'ZW875658979877',
          count: 2,
          price: '￥34.61',
          fee: '￥7',
          totalPrice: '￥41.61',
          logisticsType: '京东标准快递',
          is_out_of_stock: true,
        },
      ],
      form: {},
      pay_type: 'balance',
    };
  },
};
</script>

<style scoped>
@import '../../../assets/css/iconfont/iconfont.css';
.payTypeWrapper {
    padding-top: 10px;
}
.payTypeWrapper .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: black;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #4934b2 !important;
  box-shadow: 0 0 0 0;
}
.payTypeWrapper >>> .el-radio__input {
  display: none;
}
.payTypeWrapper .el-input--small .el-input__inner {
  height: 39px;
}
.icon-checked {
  position: absolute;
  right: 0;
  bottom: -1px;
  font-size: 27px;
  color: #4934b2;
}
.payTypeWrapper .el-radio-button {
  margin-right: 15px;
  width: 135px;
}
.payTypeWrapper .el-radio-button__inner {
  width: 135px;
  border: 1px solid #b2b3b6 !important;
  border-radius: 3px !important;
}
.payTypeWrapper .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: black;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #ff2929 !important;
  box-shadow: 0 0 0 0;
}
</style>
